import { useQuery } from '@tanstack/react-query'

import { apiGetQuizzes } from '@/apis/quiz/getQuizzes'

import { QUIZ_KEYS } from '../keys/quiz'

export const useGetQuizzes = () => {
  return useQuery({
    queryKey: [QUIZ_KEYS.LIST],
    queryFn: apiGetQuizzes,
  })
}
